// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// Analytics only needed in production
// import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCOUoT7l37A3zt9uDUxiuL5n6kkk-mWDSY",
  authDomain: "rtym-ai.firebaseapp.com",
  projectId: "rtym-ai",
  storageBucket: "rtym-ai.firebasestorage.app",
  messagingSenderId: "598730686591",
  appId: "1:598730686591:web:2cefce10c2bfecd3dbff4a",
  measurementId: "G-X49Z0KXZT3"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app)
export const auth = getAuth(app);

// Analytics disabled in development to avoid CORS issues
// Only initialize analytics in production if needed
// let analytics;
// if (process.env.NODE_ENV === 'production') {
//   const { getAnalytics } = require("firebase/analytics");
//   analytics = getAnalytics(app);
// }
export default app;